exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.cart-dropdown[data-v-56f25a5c] {\n  width: 390px;\n}\n@media (max-width: 575px) {\n.cart-dropdown[data-v-56f25a5c] {\n      max-width: 95vw;\n}\n}\n.cart-dropdown .row-total[data-v-56f25a5c] {\n    font-weight: 700;\n}\n.cart-items[data-v-56f25a5c] {\n  font-size: 0.875rem;\n}\n.cart-items a[data-v-56f25a5c] {\n    color: #000;\n    font-weight: 500;\n}\n.fast[data-v-56f25a5c] {\n  -webkit-animation-duration: 0.3s;\n          animation-duration: 0.3s;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56f25a5c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CartDropdown.vue
// module id = S2+a
// module chunks = 14